<div class="stylesheet-container" *ngIf="!isLoadingStylesheet && !isLoadingLabels && !isLoadingStylesheetData">
	<div class="search" *ngIf="stylesheet.id == undefined">
		<cpi-msp-table
			[header]="searchHeader"
			[body]="stylesheetArr"
			[height]="'50dvh'"
			[itemPadding]="'1%'"
			[insideSort]="true"
			[insidePagination]="false"
			[tableOnly]="true"
			[labels]="labels"
			(getSelectedItem)="getStylesheetById($event[0]['id'])"
			*ngIf="stylesheetArr.length > 0">
		</cpi-msp-table>

		<div class="empty-pallet" *ngIf="stylesheetArr.length == 0">
			<div>
				<span>{{
					labels['lbl_nenhum_§placeholder§_cadastrado']
						.replace('§_placeholder_§', labels.lbl_geral_tema.toLowerCase())
						.split('(a)')
						.join('')
				}}</span
				><span><fa-icon [icon]="icons.faPaintBrush"></fa-icon></span>
			</div>
		</div>

		<div class="button-container">
			<button (click)="resetStylesheet()">{{ labels.lbl_geral_registrar }}</button>
		</div>
	</div>

	<ng-container *ngIf="stylesheet.id != undefined">
		<div class="header-wrap">
			<span class="tab selected">{{ labels.lbl_geral_temas }}</span>
		</div>
		<div class="body-wrap">
			<ng-container *ngIf="!isLoadingStylesheetData">
				<ng-container>
					<div class="dotted-input-container">
						<span>{{ labels.lbl_nome_da_paleta_de_cor }} *</span>
						<input type="text" (input)="stylesheet.name = $event.target.value" [value]="stylesheet.name" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_cor_principal }} *</span>
						<input
							type="colorPicker"
							[cpAlphaChannel]="'disabled'"
							[maxLength]="0"
							[(colorPicker)]="stylesheet['primary-color-1']"
							[style.background]="stylesheet['primary-color-1']" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_geral_cor_secundaria }} *</span>
						<input
							type="colorPicker"
							[cpAlphaChannel]="'disabled'"
							[maxLength]="0"
							[(colorPicker)]="stylesheet['primary-color-2']"
							[style.background]="stylesheet['primary-color-2']" />
					</div>

					<div class="dotted-input-container">
						<span>{{ labels.lbl_logo }}</span>
						<div class="button-container">
							<div
								class="button danger"
								*ngIf="stylesheet && stylesheet.logo && stylesheet.logo.checkSum !== ''"
								(click)="cleanFileLogo()">
								<fa-icon [icon]="icons.faTrash"></fa-icon>
							</div>
							<label class="button" for="stylesheetLogo">{{
								stylesheet && stylesheet.logo && stylesheet.logo.name
									? stylesheet.logo.name
									: labels.lbl_geral_anexar_arquivo
							}}</label>
							<input type="file" accept=".jpeg,.png,.jpg" id="stylesheetLogo" #stylesheetLogo (change)="handleFileLog()" />
						</div>
					</div>

					<div *ngIf="stylesheet && stylesheet.logo && stylesheet.logo.checkSum !== ''">
						<img class="img-logo" [src]="'data:image;base64,' + stylesheet.logo.checkSum" />
					</div>
				</ng-container>

				<div class="button-container">
					<button (click)="resetStylesheet(); stylesheet.id = undefined">{{ labels.lbl_geral_voltar }}</button>
					<button
						[ngClass]="{ disabled: isCrudingStylesheet }"
						(click)="deleteStylesheet()"
						*ngIf="stylesheet.id != undefined && stylesheet.id !== ''">
						{{ labels.lbl_geral_excluir }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isCrudingStylesheet"></cpi-dot-bounce-loading-effect>
					</button>
					<button (click)="visualizeStylesheet()" *ngIf="stylesheet.id != undefined">{{ labels.lbl_geral_visualizar }}</button>
					<button [ngClass]="{ disabled: isCrudingStylesheet }" (click)="submitStylesheet()" *ngIf="stylesheet.id === ''">
						{{ labels.lbl_geral_registrar }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isCrudingStylesheet"></cpi-dot-bounce-loading-effect>
					</button>
					<button
						[ngClass]="{ disabled: isCrudingStylesheet }"
						(click)="updateStylesheet()"
						*ngIf="stylesheet.id != undefined && stylesheet.id !== ''">
						{{ labels.lbl_geral_atualizar }}
						<cpi-dot-bounce-loading-effect
							[color]="'var(--const-white)'"
							*ngIf="isCrudingStylesheet"></cpi-dot-bounce-loading-effect>
					</button>
				</div>
			</ng-container>
		</div>
	</ng-container>
</div>

<cpi-dot-bounce-loading-effect
	[color]="'var(--primary-color-1)'"
	*ngIf="isLoadingLabels || isLoadingStylesheet || isLoadingStylesheetData"></cpi-dot-bounce-loading-effect>

<div class="thinking-border" (click)="returnOriginalStylesheet()" *ngIf="isVisualizingNewStylesheet"></div>
